import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background: ${(props) => (props.overlay ? 'rgba(0, 0, 0, 0.5)' : 'transparent')};
`;

const ErrorCard = styled.div`
  background: ${(props) => props.theme.colors?.glassBackground || 'rgba(255, 255, 255, 0.1)'};
  backdrop-filter: ${(props) => props.theme.effects?.backdropBlur || 'blur(4px)'};
  border-radius: ${(props) => props.theme.effects?.borderRadiusLarge || '16px'};
  padding: 2rem;
  max-width: 90%;
  width: ${(props) => props.width || '400px'};
  text-align: center;
  color: ${(props) => props.theme.colors?.textPrimary || '#ffffff'};

  /* TV Performance Optimizations */
  transform: translateZ(0);
  will-change: transform;
`;

const ErrorIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  color: ${(props) => props.theme.colors?.error || '#ff4444'};
`;

const ErrorTitle = styled.h2`
  margin: 0 0 1rem 0;
  font-size: 1.5rem;
  font-weight: 600;
`;

const ErrorMessage = styled.p`
  margin: 0;
  font-size: 1rem;
  opacity: 0.9;
  line-height: 1.5;
`;

const ErrorDisplay = ({ message, title = 'Error', icon = '⚠️', width, overlay = true }) => {
  return (
    <ErrorContainer overlay={overlay}>
      <ErrorCard width={width}>
        <ErrorIcon>{icon}</ErrorIcon>
        <ErrorTitle>{title}</ErrorTitle>
        <ErrorMessage>{message}</ErrorMessage>
      </ErrorCard>
    </ErrorContainer>
  );
};

ErrorDisplay.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
  icon: PropTypes.string,
  width: PropTypes.string,
  overlay: PropTypes.bool,
};

export default ErrorDisplay;
